import { useSelector } from 'react-redux';
import {
  selectAuth,
} from './authSlice';

export const useAuth = () => {
  const {
    isLyfshortLoggedIn,
    updating,
    loading,
    tempData,
    progress,
    shouldConfirmDetails,
    isLoggedIn,
    error,
  } = useSelector(selectAuth);

  return {
    isLyfshortLoggedIn,
    updating,
    loading,
    tempData,
    progress,
    shouldConfirmDetails,
    isLoggedIn,
    error,
  };
};
